import { render, staticRenderFns } from "./ItemDaListaDeConversa.vue?vue&type=template&id=5c6fc330&"
import script from "./ItemDaListaDeConversa.vue?vue&type=script&lang=js&"
export * from "./ItemDaListaDeConversa.vue?vue&type=script&lang=js&"
import style0 from "./ItemDaListaDeConversa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports